export class FormController {
  private label;

  constructor() {
    if (document.querySelectorAll('.js-form').length) {
      const formElements = document.querySelectorAll('.js-condition');
      formElements.forEach(formElement => {
        if (formElement instanceof HTMLElement) {
          const form = formElement.closest('.js-form');
          if (form) {
            if (formElement.dataset.conditionFieldid) {
              const fieldId = form.id + '-' + formElement.dataset.conditionFieldid.replace(/[{}]/g, '');
              this.init(fieldId, formElement.dataset.conditionValue, formElement, formElement.dataset.conditionFieldid.replace(/[{}]/g, ''));
            }
          }
        }
      });
    }
  }

  init(fieldId, value, formElement, typeOfTheFieldWithCondition) {
    const field = document.querySelector('#' + fieldId) as HTMLInputElement;
    switch (true) {
      case typeOfTheFieldWithCondition.indexOf('select') !== -1:
        this.addConditionOnSelectInput(field, value, formElement);
        break;
      case typeOfTheFieldWithCondition.indexOf('checkbox') !== -1:
        this.addConditionBasedOnCheckboxInput(field, value, formElement);
        break;
      case typeOfTheFieldWithCondition.indexOf('radio') !== -1:
        const radioButtons = document.querySelectorAll('input[type="radio"]');
        this.addConditionBasedOnRadioInput(radioButtons, value, formElement);
        break;
      default:
        break;
    }
    if (formElement.tagName.toLowerCase() === 'select') {
      this.hideChoices(formElement);
    }
  }

  private addConditionOnSelectInput(field, value, formElement) {
    if (field.value === value) {
      this.showElement(formElement);
    } else {
      this.hideElement(formElement);
    }
    field.addEventListener('change', e => {
      if (e.currentTarget.value === value) {
        this.showElement(formElement);
      } else {
        this.hideElement(formElement);
      }
    });
  }

  private addConditionBasedOnCheckboxInput(field, value, formElement) {
    if (field.checked === value) {
      this.showElement(formElement);
    } else {
      this.hideElement(formElement);
    }
    field.addEventListener('change', e => {
      if (e.currentTarget.checked) {
        this.showElement(formElement);
      } else {
        this.hideElement(formElement);
      }
    });
  }

  private addConditionBasedOnRadioInput(fields, value, formElement) {
    this.label = document.querySelector('label[for="' + formElement.id + '"]') || null;
    fields.forEach( field => {
      if (field.checked === value) {
        this.showElement(formElement);
      } else {
        this.hideElement(formElement);
      }
      field.addEventListener('click', e => {
        if (e.currentTarget.value === value) {
          this.showElement(formElement);
        } else {
          this.hideElement(formElement);
        }
      });
    });
  }

  private showElement(formElement) {
    if (formElement.tagName.toLowerCase() === 'select') {
      let choice = formElement.closest('.choices');
      if (choice instanceof HTMLElement) {
        choice.classList.remove('hidden');
      }
    }
    formElement.classList.remove('hidden');
    const label = document.querySelector('label[for="' + formElement.id + '"]');
    if (label) {
      label.classList.remove('hidden');
    }
    if (formElement.classList.contains('js-condition-required')) {
      formElement.required = true;
    }
  }

  private hideElement(formElement) {
    formElement.classList.add('hidden');
    const label = document.querySelector('label[for="' + formElement.id + '"]');
    if (label) {
      label.classList.add('hidden');
    }
    if (formElement.classList.contains('js-condition-required')) {
      formElement.required = false;
    }
    this.hideChoices(formElement);
  }

  private async hideChoices(formElement) {
    const choice = await this.waitForChoice(formElement);
    if (choice instanceof HTMLElement) {
      choice.classList.add('hidden');
    }
  }

  private waitForChoice(formElement: HTMLElement) {
    return new Promise(resolve => {
      if (formElement.closest('.choices')) {
        return resolve(formElement.closest('.choices'));
      }

      const observer = new MutationObserver(mutations => {
        if (formElement.closest('.choices')) {
          resolve(formElement.closest('.choices'));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }
}
